export enum PageKey {
  DASHBOARD = 'dashboard',
  LOGIN = 'login',
  USERS = 'users',
  TRACKS = 'tracks',
  CATEGORIES = 'categories',
  TAGS = 'tags',
  COURSES = 'courses',
  COURSE_DRAFTS = 'course-drafts',
  COURSE_TRASH = 'course-trash',
  CRUD = 'crud'
}
